import { parse, isValid, format } from 'date-fns';
export const formatDate = format;
export const isDateValid = isValid;
export const DATE_FORMAT_ISO8601_DATE = 'yyyy-MM-dd';
export const DATE_FORMAT_ISO8601_DATETIME = "yyyy-MM-dd'T'HH:mm:ss.SSS";
export const DATE_FORMAT_ISO8601_DATETIME_WITH_TZ = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX";
export const DATE_FORMAT_MONTH_DAY_YEAR = 'M/d/yyyy';
export const DATE_FORMAT_MONTH_DAY_YEAR_LEADING_ZEROS = 'MM/dd/yyyy';
const defaultParseDateFormats = [
    "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
    "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
    "yyyy-MM-dd'T'HH:mm:ss.SSS",
    'yyyy-MM-dd',
    'yyyy-M-d',
    'yyyy-MM-dd HH:mm:ss XX',
    'yyyy-MM-dd HH:mm:ss',
    'MM/dd/yyyy',
    'M/d/yyyy',
];
const asArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    return [value];
};
export const parseDate = (input, dateFormats) => {
    if (input instanceof Date) {
        return input;
    }
    const parseDateFormats = dateFormats ? asArray(dateFormats) : defaultParseDateFormats;
    const referenceDate = new Date();
    for (const format of parseDateFormats) {
        const result = parse(input, format, referenceDate);
        if (isValid(result)) {
            return result;
        }
    }
    // fallback to an invalid date to make it obvious we've received an invalid date format.
    // We could return `new Date(input)` and try letting the browser parse, but browser inconsistency
    // make it difficult to catch bugs before hitting production
    return new Date(NaN);
};
//# sourceMappingURL=date.js.map